import React, { useEffect } from "react";
import { useProductStore } from "../../stores/useProductStores";

const ProductList = () => {
  const { newProducts, searchResults, getNewCollections } = useProductStore();

  useEffect(() => {
    getNewCollections();
  }, []);

  const displayProducts = searchResults.length > 0 ? searchResults : newProducts;

  return (
    <div>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mt-4">
        {displayProducts.length > 0 ? (
          displayProducts.map((product) => (
            <div key={product.id} className="border p-4 rounded-lg shadow-md">
              <img src={product.image} alt={product.name} className="w-full h-40 object-cover rounded-md"  loading="lazy"
               decoding="async" />
              <h2 className="text-lg font-semibold">{product.name}</h2>
              <p className="text-gray-600">${product.price}</p>
              {Number(product.available_quantity ?? 0) <= 0 && (
                <p className="text-red-700 text-sm">Out of stock</p>
              )}
              {Number(product.available_quantity ?? 0) > 0 &&
                Number(product.available_quantity) <= 2 && (
                  <p className="text-red-700 text-sm">
                    Only {product.available_quantity} left
                  </p>
                )}
            </div>
          ))
        ) : (
          <p>No products found</p>
        )}
      </div>
    </div>
  );
};

export default ProductList;
